import axios from "../../js/project-axios.js";
import application from "@/js/application.js";

const getInfo = () => {
    return axios.get("/mine/getInfo");
};

const updateInfo = (user, config) => {
    return axios.post("/mine/updateInfo", user, config);
};

const getAvatar = token => {
    return axios.get("/mine/getAvatar", {
        params: {
            token
        }
    });
};

const $getAvatarUrl = token => {
    return application.server + "/mine/getAvatar?token=" + token;
};

const changeAvatar = avatar => {
    let formData = new FormData();
    formData.append("avatar", avatar);
    return axios.post("/mine/changeAvatar", formData);
};

const getSafeInfo = () => {
    return axios.get("/mine/getSafeInfo");
};

export default {
    getInfo,
    updateInfo,
    getAvatar,
    $getAvatarUrl,
    changeAvatar,
    getSafeInfo
};